module.exports = __webpack_public_path__ + "img/chevron-swipe-arrow.svg";